import React, { useState, useEffect, useRef } from 'react'
import './stylestext.css'
import { withWidth } from '@material-ui/core';
import { palette } from '../../../../../variables/config';

const vector_size = {
  'xs': {width:1332,height:642, offset_x:0, offset_y:0, scale:0.1},
  'sm': {width:1332,height:642, offset_x:0, offset_y:0, scale:0.1},
  'md': {width:1332,height:642, offset_x:0, offset_y:0, scale:0.1},
  'lg': {width:1332,height:642, offset_x:0, offset_y:0, scale:0.1},
  'xl': {width:1332,height:642, offset_x:0, offset_y:0, scale:0.1},
}

const LogoGeneralMask = ({scale, width}) => {

  const [local_window, setWindow] = useState({
    width:0,
    height:0
  })

  let myContainer = useRef()

  useEffect(() => {
    let temp = {...local_window}
    const height = myContainer.clientHeight;
    const width = myContainer.clientWidth
    temp.height = height
    temp.width = width
    setWindow(temp)
  }, [])

  const updateDimensions = () => {
    let temp = {...local_window}
    const height = myContainer.clientHeight;
    const width = myContainer.clientWidth
    temp.height = height
    temp.width = width
    setWindow(temp);
  }

  const logo = vector_size[width]

  //const start_width = 1332
  //const start_height = 642

  const start_width = 500
  const start_height = 500

  let current_scale = logo.scale - (1-scale)

  //const x_offset = local_window.width/2 - (start_width*current_scale)/2
  //const y_offset = local_window.height/2 - (start_height*current_scale)/2 + (scale-1)*250

  const x_offset = local_window.width/2 - (start_width*current_scale)/2
  const y_offset = local_window.height/2 - (start_height*current_scale)/2 

  //console.log(y_offset)

  return(
    <svg height="100%" width="100%" ref={(ref) => {myContainer = ref}}>
      <defs>
        <mask id="mask" x="0" y="0" height="100%" width="100%">
          <rect x="0" y="0" height="100%" width="100%" />
            <g transform={`translate(${x_offset},${y_offset})scale(${current_scale})`}>
              {/* <polygon points="983.75,12.242 350.791,12.242 12.104,472.203 12.104,629.551 354.839,629.551 669.294,250.319 
              975.653,629.551 1322.376,629.551 1322.376,472.203 "/>
              <polygon points="482.092,12.235 983.746,12.235 1322.372,472.205 1322.372,629.552 977.361,629.552 "/> */}
              {/* <polygon fill="#D64189" points="250 180, 1000 180, 1000 500, 250 500" />  */}
              <path   d="M492.7,372.5l-195-337.6C279,2.3,232,2.3,213.3,34.9l-195,337.6C-0.4,405,23,445.6,60.6,445.6h389.9
                  C488,445.6,511.4,405,492.7,372.5z M255.5,405.3c-66.8,0-121-54.2-121-121s54.2-121,121-121s121,54.2,121,121
                  S322.3,405.3,255.5,405.3z"/>
            </g>
        </mask>
      </defs>
      <rect x="0" y="0" height="100%" width="100%" style={{fill: palette.primary.main}}/>
    </svg>
  )
  
}

export default withWidth()(LogoGeneralMask)